import { TextLabel } from '@procurify/ui'

import { AuditLogRecordLabelStyled } from './styles/AuditLogRecordLabelStyled'
import { type AuditLogStatusEnum } from '../../entities/enums/AuditLogStatusEnum'

export interface IAuditLogRecordLabelProps {
  status: AuditLogStatusEnum
}

export const AuditLogRecordLabel = ({ status }: IAuditLogRecordLabelProps) => {
  return (
    <AuditLogRecordLabelStyled>
      <TextLabel>{status}</TextLabel>
    </AuditLogRecordLabelStyled>
  )
}
